module.exports = __webpack_public_path__ + "img/hederprofile.32f90fef.svg";